import * as React from 'react';
import * as util from '../../utils/util';
import { useNavigate } from 'react-router-dom';

import MuiBox from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { styled } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import mainbg from '../../assets/main/mainbg.png';
import img1 from '../../assets/main/img1.png';
import img2 from '../../assets/main/img2.png';
import img3 from '../../assets/main/img3.png';
import img4 from '../../assets/main/img4.png';

// Box 타입 추론(오버로드) 폭발 방지용: 이 파일에서만 Box를 any로 사용
const Box = MuiBox as any;

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const TopMan = styled('img')({
  marginLeft: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const topContainer: SystemStyleObject<Theme> = {
  height: 'auto',
  backgroundImage: `url(${mainbg})`,
  backgroundRepeat: 'no-repeat',
  boxShadow: 'none',
  minWidth: '320px',
  backgroundColor: '#FFE5D8',
  borderRadius: '0 0 40px 40px',
  backgroundSize: 'contain',
  overflow: 'hidden',
};

const toplogo: SystemStyleObject<Theme> = {
  height: 'auto',
  backgroundImage: `url(${mainbg})`,
  backgroundRepeat: 'no-repeat',
  boxShadow: 'none',
  minWidth: '320px',
  backgroundColor: '#FFE5D8',
  backgroundSize: 'cover',
  overflow: 'hidden',
  maxWidth: '1198px',
};

const topMan: SystemStyleObject<Theme> = {
  position: 'relative',
  top: '27%',
  right: '14px',
};

const MainHomeTop = () => {
  const navigate = useNavigate();

  function handleClickMyButton() {
    if (util.strNull((window as any).localStorage.userCusID) !== '') {
      alert('로그인되어있어 나중에는 마이페이지로 이동합니다.');
      navigate('/MoreMenu');
    } else {
      navigate('/login');
    }
  }

  // 새로고침 이미지 변경
  const ImgArr = [img1, img2, img3, img4];
  const randomIndex = Math.floor(Math.random() * ImgArr.length);
  const mainTopImg = ImgArr[randomIndex];

  return (
    <React.Fragment>
      <Box sx={topContainer}>
        <Box sx={{ display: 'flex' }}>
          {/* logo */}
          <Box position={'fixed'} width={'100%'} zIndex={999} sx={toplogo}>
            <Stack direction={'row'}>
              <Box>
                <ButtonBase sx={{ width: 180, height: 50, ml: 1 }} onClick={handleClickMyButton}>
                  <Img alt="Dual" src="/dual.png" />
                </ButtonBase>
              </Box>
            </Stack>
          </Box>

          <Grid container spacing={2} direction="row" sx={{ mt: 6 }}>
            <Grid item container xs sx={{ alignItems: 'center' }} direction="column" justifyContent="center">
              <Typography
                className="topText"
                sx={{
                  fontSize: '2.4rem',
                  color: '#FF664E',
                  fontWeight: 900,
                  textEmphasisStyle: 'circle',
                  textIndent: '-10px',
                }}
              >
                건강검진
              </Typography>

              <Typography sx={{ fontSize: '1.8rem', color: '#EF8322', fontWeight: 500, textIndent: '-12px' }} gutterBottom>
                받으셨나요
              </Typography>
            </Grid>

            <Grid item sx={{ width: '45%', pt: 0, pl: '0px !important', pr: 2 }}>
              <Img alt="care" src={mainTopImg} />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default MainHomeTop;
